import React from 'react';

import Navigation from './Navigation';

export default class Menu extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
    };
    this.timeout = null;
    this.toggleActive = this.toggleActive.bind(this);
    this.deactivate = this.deactivate.bind(this);
    this.delayedDeactivate = this.delayedDeactivate.bind(this);
  }

  componentDidUpdate() {
    const { isActive } = this.state;

    if (isActive) {
      document.documentElement.classList.add('overflow-hidden');
    } else {
      document.documentElement.classList.remove('overflow-hidden');
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  toggleActive() {
    const { isActive } = this.state;
    this.setState({ isActive: !isActive });
  }

  deactivate() {
    this.setState({ isActive: false });
  }

  delayedDeactivate() {
    const transition = () => {
      this.setState({ isActive: false });
      clearTimeout(this.timeout);
    };

    this.timeout = setTimeout(transition, 375);
  }

  render() {
    const { isActive } = this.state;

    return (
      <>
        <button
          type="button"
          aria-label="Menu"
          className={`Menu ${
            isActive ? 'Menu--active' : ''
          }`}
          onClick={this.toggleActive}
        >
          <span aria-hidden="true">
            <div className="Menu__bar">
              <div className="Menu__mask" />
            </div>
            <div className="Menu__bar">
              <div className="Menu__mask" />
            </div>
            <div className="Menu__bar">
              <div className="Menu__mask" />
            </div>
          </span>
        </button>
        <Navigation
          isActive={isActive}
          delayedDeactivate={this.delayedDeactivate}
        />
        <button
          type="button"
          className={`Menu__overlay ${
            isActive ? 'Menu__overlay--active' : ''
          }`}
          onClick={this.deactivate}
        >
          Fechar menu
        </button>
      </>
    );
  }
}
